import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";
import { A } from "core/Typography";

import { AttributionFormContainer, CopyButton } from "./styles";
import colors from "core/colors";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";

import { BROWSE_ICONS_BY_TAG } from "data/links";

const AttributionForm = ({ onDesktop }) => {
    const {
        attributionCopied,
        copyAttribution,
        iconTitle,
        creatorName,
        titleSlug
    } = useAttributionBacklink();

    return (
        <AttributionFormContainer
            data-testid="attribution-form"
            darkMode={onDesktop}
        >
            <BodyText
                size="sm"
                type="p"
                copyColor={
                    onDesktop ? colors.primary.snow : colors.secondary.oolong
                }
            >
                {iconTitle} by {creatorName} from{" "}
                <A
                    href={BROWSE_ICONS_BY_TAG.replace(":term", titleSlug)}
                    target="_blank"
                >
                    Noun Project
                </A>
            </BodyText>
            <CopyButton
                onClick={copyAttribution}
                size="md"
                darkMode={onDesktop}
            >
                {attributionCopied
                    ? "Copied"
                    : onDesktop
                    ? "Copy Link"
                    : "Copy"}
            </CopyButton>
        </AttributionFormContainer>
    );
};

AttributionForm.propTypes = {
    onDesktop: PropTypes.bool
};

export default AttributionForm;
